import { Text } from '@chakra-ui/react'
import type { ReactNode } from 'react'

const srOnlyProps = {
  position: 'absolute' as const,
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden' as const,
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap' as const,
  borderWidth: 0,
}

/**
 * Page-level H1 for screens where UniversalHeader already shows the title as chrome.
 * Keeps exactly one semantic H1 without a second visible title (SEO 5.5).
 */
export default function SeoPageTitle({ children }: { children: ReactNode }) {
  return (
    <Text as='h1' {...srOnlyProps}>
      {children}
    </Text>
  )
}
